import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.css'
})
export class DropdownComponent {
  @Input() options: any[] = [];
  @Input() selectedOption: any;
  @Input() placeHolderText: any = 'Select value';
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  onChange(event: any) {
    this.onSelect.emit(this.selectedOption);
  }
}
